import { v4 } from "uuid";
import type {
  MessageResult,
  UserResult
} from "../../api/generated/data-contracts";

export const createSendingMessage = (
  message: string,
  sender: UserResult
): MessageResult => {
  const trimmedMessage = message.trim();

  const msg: MessageResult = {
    content: trimmedMessage,
    sender,
    id: 0,
    createdTimestamp: Date.now(),
    uuid: v4()
  };

  return msg;
};
